import { useMutation, useQuery } from "@tanstack/react-query";
import axios, { AxiosResponse } from "axios";
const BASE_URL = "https://vefaa.thepocman.com";
// const BASE_URL = "http://localhost:4321";

type BrandsResponse = { marques: string[][] };
const fetchBrands = (): Promise<AxiosResponse<BrandsResponse>> =>
  axios.get(`${BASE_URL}/algo/brands`);
export const useBrandsQuery = () =>
  useQuery({
    queryKey: ["BackEnd", "Brands"],
    queryFn: fetchBrands,
    select: (response) => response.data.marques.map((brand) => brand[0]),
  });

export type ResultResponse = {
  economie_par_mois: number;
  temps_remboursement_mois: number;
  temps_trajet_velo: number;
  pollution_par_mois: number;
  aide_totale: number;
  aide_sc: number;
  aide_mobilite_durable: number;
  aide_fonctionnaire: number;
  prix_essence: number;
  consommation: number;
  pollution: number;
  distance: number;
  temps: number;
  url: string;
};
const fetchResult = (values: string, request_id: string): Promise<AxiosResponse<ResultResponse>> =>
  axios.get(`${BASE_URL}/algo/result?values=${values}&request_id=${request_id}`);
export const useResultQuery = ({ values, request_id }: { values: string, request_id: string }) =>
  useQuery({
    queryKey: ["BackEnd", "Result", values, request_id],
    queryFn: () => fetchResult(values, request_id),
    select: (response) => response.data,
  });

const fetchTrackFormSubmission = (values: string): Promise<AxiosResponse<{request_id: string}>> =>
axios.post(`${BASE_URL}/algo/track_form_submission`, { values });
export const useTrackFormSubmissionMutation = () =>
  useMutation({mutationFn: (values: string) => fetchTrackFormSubmission(values)});

export type ModelsResponse = string[];
const fetchModels = (brand: string): Promise<AxiosResponse<ModelsResponse>> =>
  axios.get(`${BASE_URL}/algo/models?brand=${brand}`);
export const useModelsQuery = (brand: string) =>
  useQuery({
    enabled: !!brand,
    queryKey: ["BackEnd", "Models", brand],
    queryFn: () => fetchModels(brand),
    select: (response) => response.data,
  });

export type FuelsResponse = string[];
const fetchFuels = (brand: string, model: string): Promise<AxiosResponse<FuelsResponse>> =>
  axios.get(`${BASE_URL}/algo/fuels?brand=${brand}&model=${model}`);
export const useFuelsQuery = (brand: string, model: string) =>
  useQuery({
    enabled: !!brand && !!model,
    queryKey: ["BackEnd", "Fuels", brand, model],
    queryFn: () => fetchFuels(brand, model),
    select: (response) => response.data,
  });

export type YearsResponse = number[];
const fetchYears = (brand: string, model: string, fuel: string): Promise<AxiosResponse<YearsResponse>> =>
  axios.get(`${BASE_URL}/algo/years?brand=${brand}&model=${model}&fuel=${fuel}`);
export const useYearsQuery = (brand: string, model: string, fuel: string) =>
useQuery({
  enabled: !!brand && !!model && !!fuel,
  queryKey: ["BackEnd", "Years", brand, model, fuel],
  queryFn: () => fetchYears(brand, model, fuel),
  select: (response) => response.data,
});